import React from 'react';
import { ToastPosition } from 'react-toastify';
import FieldsTab from '../../Tabs/FieldsTab/index';
import ConditionalTab from '../../Tabs/ConditionalTab/index';
import EmailTab from '../../Tabs/EmailTab/index';
import SettingTab from '../../Tabs/SettingTab/index';
import AutoInjectTab from '../../Tabs/AutoInjectTab/index';
import { ContactFormConfig, GenericFieldType } from '../../../../types/ContactForm';

export const TABS = ['Felder', 'Anzeigelogik', 'E-Mail', 'Einstellungen', 'Template-Inject'] as const;

export type TabName = typeof TABS[number];

interface TabComponentsProps {
    config: ContactFormConfig;
    updateConfig: (property: string, value: unknown) => void;
    updateField: (index: number, property: string, value: unknown) => void;
    addField: (step?: number) => void;
    addGenericField: (genericType?: GenericFieldType, step?: number) => void;
    removeField: (index: number) => void;
    moveField: (index: number, direction: 'up' | 'down') => void;
    showModal: (data: { heading?: React.ReactNode; content: React.ReactNode; fullscreen: boolean; size?: string }) => void;
    hideModal: () => void;
    showToast: (position: ToastPosition, type: 'info' | 'success' | 'warning' | 'error' | 'default', message: string) => void;
    saveAllSettings: () => Promise<void>;
    shopUrl: string;
    setShopUrl: (url: string) => void;
}

export const getTabComponents = (props: TabComponentsProps) => ({
    'Felder': (
        <FieldsTab
            config={props.config}
            updateConfig={props.updateConfig}
            updateField={props.updateField}
            addField={props.addField}
            addGenericField={props.addGenericField}
            removeField={props.removeField}
            moveField={props.moveField}
            showModal={props.showModal}
            hideModal={props.hideModal}
            showToast={props.showToast}
            saveAllSettings={props.saveAllSettings}
        />
    ),
    'Anzeigelogik': (
        <ConditionalTab
            config={props.config}
            updateConfig={props.updateConfig}
        />
    ),
    'E-Mail': (
        <EmailTab
            config={props.config}
            updateConfig={props.updateConfig}
        />
    ),
    'Einstellungen': (
        <SettingTab
            config={props.config}
            updateConfig={props.updateConfig}
        />
    ),
    'Template-Inject': (
        <AutoInjectTab
            config={props.config}
            updateConfig={props.updateConfig}
            shopUrl={props.shopUrl}
            setShopUrl={props.setShopUrl}
        />
    )
});


